var _rect, _rect2, _path, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.442413,
    y: 0.25,
    width: 21.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2549",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.442413,
    y: 0.25,
    width: 21.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2549)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.192413 10.6667H22.1924V5.33333H0.192413V10.6667Z",
    fill: "#0C47B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.192413 16H22.1924V10.6667H0.192413V16Z",
    fill: "#E53B35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1704 2.53333H5.9287C4.85351 2.53333 3.97071 3.38341 3.93013 4.45784L3.74072 9.47192C3.71792 10.0755 3.96913 10.6571 4.42423 11.0543L6.29612 12.6879C7.30069 13.5646 8.7984 13.5646 9.80297 12.6879L11.6749 11.0543C12.13 10.6571 12.3812 10.0755 12.3584 9.47192L12.169 4.45784C12.1284 3.38341 11.2456 2.53333 10.1704 2.53333Z",
    fill: "#F73744",
    stroke: "white",
    strokeWidth: 1.33333
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_2549",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 11,
    height: 14
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1704 2.53333H5.9287C4.85351 2.53333 3.97071 3.38341 3.93013 4.45784L3.74072 9.47192C3.71792 10.0755 3.96913 10.6571 4.42423 11.0543L6.29612 12.6879C7.30069 13.5646 8.7984 13.5646 9.80297 12.6879L11.6749 11.0543C12.13 10.6571 12.3812 10.0755 12.3584 9.47192L12.169 4.45784C12.1284 3.38341 11.2456 2.53333 10.1704 2.53333Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.33333
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_2549)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52574 8.86667C7.52574 8.68257 7.37651 8.53333 7.19241 8.53333H6.28765C6.10355 8.53333 5.95432 8.38409 5.95432 8.2V7.8C5.95432 7.6159 6.10355 7.46667 6.28765 7.46667H7.19241C7.37651 7.46667 7.52574 7.31743 7.52574 7.13333V6.73333C7.52574 6.54924 7.37651 6.4 7.19241 6.4H6.81146C6.62736 6.4 6.47812 6.25076 6.47812 6.06667V5.66667C6.47812 5.48257 6.62736 5.33333 6.81146 5.33333H7.19241C7.37651 5.33333 7.52574 5.18409 7.52574 5V4.6C7.52574 4.4159 7.67498 4.26667 7.85908 4.26667H8.24003C8.42412 4.26667 8.57336 4.4159 8.57336 4.6V5C8.57336 5.18409 8.7226 5.33333 8.9067 5.33333H9.28765C9.47174 5.33333 9.62098 5.48257 9.62098 5.66667V6.06667C9.62098 6.25076 9.47174 6.4 9.28765 6.4H8.9067C8.7226 6.4 8.57336 6.54924 8.57336 6.73333V7.13333C8.57336 7.31743 8.7226 7.46667 8.9067 7.46667H9.81146C9.99555 7.46667 10.1448 7.6159 10.1448 7.8V8.2C10.1448 8.38409 9.99555 8.53333 9.81146 8.53333H8.9067C8.7226 8.53333 8.57336 8.68257 8.57336 8.86667V10.3333C8.57336 10.5174 8.42412 10.6667 8.24003 10.6667H7.85908C7.67498 10.6667 7.52574 10.5174 7.52574 10.3333V8.86667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1039 10.7404C5.83024 10.9447 4.90668 11.5508 4.90668 12.2667C4.90668 13.1503 6.31378 13.8667 8.04953 13.8667C9.78529 13.8667 11.1924 13.1503 11.1924 12.2667C11.1924 11.5508 10.2688 10.9447 8.99517 10.7404C8.82653 10.3813 8.46648 10.1333 8.04953 10.1333C7.63259 10.1333 7.27254 10.3813 7.1039 10.7404Z",
    fill: "#1251A1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/sk.ca6573da9882cd95cb84c68c4b5488b0.svg";
export { ForwardRef as ReactComponent };